import { PageHeader } from "@justworkshr/milo-components";
import styles from "./RenewalRateInvoice.module.css";
import renewalRateInvoice from "assets/sample_documents/sample_renewals_document.pdf";

const RenewalRateInvoice = (): JSX.Element => {
  return (
    <div className={styles.container}>
      <PageHeader
        title="What does this document contain?"
        className={styles.headerContainer}
      />
      <div className={styles.listItem}>
        Renewals Document should contain:
        <ul>
          <li>Date of renewal</li>
          <li>Current rates per plan</li>
          <li>Renewal rates per plan</li>

          <li>Plan Names</li>
        </ul>
      </div>
      <iframe
        title="current_invoice"
        src={renewalRateInvoice}
        width="100%"
        height="500px"
      />
    </div>
  );
};
export default RenewalRateInvoice;
